import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyCurationDetails = loadable(
  () =>
    import(
      /* webpackChunkName: "content/catalog/curationdetails" */
      '.'
    ),
);
